import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const collapsibleText: DataBindingComponentModel = {
  panel: {
    height: 212,
    title: 'Connect_Panel_Title_CollapsibleText',
    helpId: '313ea5f6-d081-4722-9ef9-62a4423785c1',
  },
  componentName: 'ellipsis_text_db_comp_name',
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'collapsibleTextRole',
      bindings: [
        {
          title: 'Connect_Panel_Connect_CollapsibleText_Label',
          prop: 'text',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.email,
            FieldType.number,
            FieldType.dateTime,
            FieldType.time,
            FieldType.url,
            FieldType.address,
            FieldType.richText,
          ],
          defaultFieldType: FieldType.text,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'ellipsis_text_dataBinding_gfpp_edit_text',
              label: 'ellipsis_text_db_edit_text_label',
            },
          },
        },
      },
      manageContentPanel: {
        description: 'ellipsis_text_db_manage_content',
      },
    },
  ],
  compactErrorPanel: true,
}
